import { render, staticRenderFns } from "./tenants.vue?vue&type=template&id=44c7f9b4&scoped=true&"
import script from "./tenants.vue?vue&type=script&lang=js&"
export * from "./tenants.vue?vue&type=script&lang=js&"
import style0 from "./tenants.vue?vue&type=style&index=0&id=44c7f9b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7f9b4",
  null
  
)

export default component.exports